import { useState, useEffect } from 'react';

export const useOptimisticInvite = row => {
    const [optimisticUpdates, setOptimisticUpdates] = useState(new Set());

    const markAsSent = (pawnId, deploymentId) => {
        const key = `${pawnId}_${deploymentId}`;
        setOptimisticUpdates(prev => new Set([...prev, key]));

        // Clear the optimistic update after 45 seconds to avoid stale state
        setTimeout(() => {
            setOptimisticUpdates(prev => {
                const newSet = new Set(prev);
                newSet.delete(key);
                return newSet;
            });
        }, 45000);
    };

    const isOptimisticallyUpdated = () => {
        const key = `${row.pawnId}_${row.deploymentId}`;
        return optimisticUpdates.has(key);
    };

    // Clear optimistic updates when real data shows the message has been sent
    useEffect(() => {
        if (row.numberOfTimesInvited > 0 && row.messages && row.messages.length > 0) {
            const key = `${row.pawnId}_${row.deploymentId}`;
            setOptimisticUpdates(prev => {
                const newSet = new Set(prev);
                newSet.delete(key);
                return newSet;
            });
        }
    }, [row.numberOfTimesInvited, row.messages, row.pawnId, row.deploymentId]);

    return {
        isOptimisticallyUpdated: isOptimisticallyUpdated(),
        markAsSent: () => markAsSent(row.pawnId, row.deploymentId),
    };
};
